/**************************************************
 * Nombre:       Formulario_Lead_Datos.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Lead_Contacto_Fecha from "./Formulario_Lead_Contacto_Fecha";
import Tarjetas_Citas_Tel from "../Tarjetas/Tarjetas_Citas_Tel";

const Formulario_Lead_Contactos = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Cita',
        dato: 'contactos',
        Formulario: Formulario_Lead_Contacto_Fecha,
        Tarjeta: Tarjetas_Citas_Tel
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Lead_Contactos